import requestJWT from "utils/requestJWT";
import request from "utils/request";

const getAllByAdminApi = async (query, sort, page, tourType) => {
    return await requestJWT.get(`/tour/get-all-by-admin?query=${query}&sort=${sort}&page=${page}&item=5&tourtype=${tourType}`);
};

const getRandomApi = async () => {
    return await request.get(`/tour/get-random`);
};

const createApi = async (data) => {
    return await requestJWT.post(`/tour/create`, data);
};

const updateApi = async (id, data) => {
    return await requestJWT.put(`/tour/${id}/update`, data);
};

const deleteApi = async (id) => {
    return await requestJWT.delete(`/tour/${id}/remove`);
};

const getTourDetailApi = async (slug, account) => {
    return await request.get(`/tour/get-by-slug/${slug}${account && account !== "" ? "?account=" + account : ""} `);
};

export {
    getAllByAdminApi,
    createApi,
    updateApi,
    deleteApi,
    getRandomApi,
    getTourDetailApi
};
